import { NotificationStatus } from '@/features/notification/types'

import { PaginationInfo, ResponseMetadata } from './common'

/**
 * Notification schema types
 */

export enum NotificationType {
  NewComment = 'new comment',
  CommentResolved = 'comment resolved',
  UserMentioned = 'user_mentioned',
  Deadline = 'deadline_today',
  DeadlinePassed = 'deadline_passed',
  DeadlineApproaching = 'deadline_approaching',
  AssignedDeliverable = 'deliverable_set_reassigned',
  ReassignedDeliverable = 'deliverable_set_reassigned_away',
  SubtaskCompleted = 'subtask_completed',
  SubtaskReopen = 'subtask_reopened',
  SubtaskDeleted = 'subtask_deleted',
}

export enum ResourceType {
  Comment = 'comment',
  Deliverable = 'deliverable',
  Subtask = 'subtask',
  Thread = 'thread',
}

export interface Notification {
  id: string
  user_id: string
  notification_type: NotificationType
  title: string
  message: string
  resource_type: ResourceType
  resource_id: string
  metadata: Record<string, string>
  read_at: string | null
  delivered_at: string
  created_at: string
  created_by: string
}

/**
 * Request body for listing notifications
 */
export interface RequestListNotifications {
  /** Pagination offset (default: 0) */
  offset?: number
  /** Pagination limit (default: 20) */
  limit?: number
  /** Optional filter criteria */
  filter_by?: {
    notification_type?: string[]
    status?: NotificationStatus[]
    [key: string]: unknown[] | undefined
  }
  /** Optional sort criteria (e.g., "+created_at", "-created_at") */
  sort_by?: string
  /** Optional search query */
  q?: string
}

/**
 * Success response for listing notifications
 */
export interface SuccessResponseListNotifications {
  /** Always true for success responses */
  success: boolean
  /** List of notifications */
  data: Notification[]
  /** Response metadata */
  metadata: ResponseMetadata
  /** Pagination info */
  pagination: PaginationInfo | null
  /** HATEOAS links */
  links: { [key: string]: string } | null
  /** Non-blocking warnings */
  warnings: string[] | null
}
